module.exports = __webpack_public_path__ + "static/media/miami.25976b41.jpeg";